/* unplugin-vue-components disabled */import script from "./Tab2Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab2Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Tab2Dialog.vue?vue&type=style&index=0&id=cc0280d2&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc0280d2"]])

export default __exports__